<template>
  <div class="contract-use-file">
    <h3 style="margin-bottom:30px">合约服务接口调用示例</h3>
    <div class="item">
      <h4>第一步：初始化公私钥和地址</h4>
      <img class="image" src="@/assets/images/生成公私钥.jpg" alt />
    </div>
    <div class="item">
      <h4>第二步：查询地址信息</h4>
      <img class="image" src="@/assets/images/获取账户信息.jpg" alt />
    </div>
    <div class="item">
      <h4>第三步：私钥加密</h4>
      <img class="image" src="@/assets/images/私钥加密.jpg" alt />
    </div>
    <div class="item">
      <h4>第四步：合约发布</h4>
      <h5>1. 合约文件发布</h5>
      <img class="image" src="@/assets/images/合约发布v2.jpg" alt />
      <h5>2. 合约abi发布</h5>
      <img class="image" src="@/assets/images/abi发布合约.jpg" alt />
    </div>
    <div class="item">
      <h4>第五步：合约交易</h4>
      <img class="image" src="@/assets/images/合约交易.jpg" alt />
    </div>
    <div class="item">
      <h4>第六步：合约调用</h4>
      <img class="image" src="@/assets/images/合约调用.jpg" alt />
    </div>
    <div class="item">
      <h4>第七步：hash查交易</h4>
      <img class="image" src="@/assets/images/hash查交易.jpg" alt />
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.contract-use-file {
  padding-left: 30px;
  padding-top: 10px;
  .item {
    margin-bottom: 30px;
    .image {
      width: 800px;
    }
  }
}
</style>